<h2 mat-dialog-title>{{ data.title }}</h2>
<mat-dialog-content>
  <p>{{ data.message }}</p>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button matButton (click)="onCancel()">
    {{ data.cancelText || 'キャンセル' }}
  </button>
  <button matButton="tonal" [color]="data.color || 'primary'" (click)="onConfirm()">
    {{ data.confirmText || 'OK' }}
  </button>
</mat-dialog-actions>
